import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-selleronboard-steps',
  templateUrl: './selleronboard-steps.component.html',
  styleUrls: ['./selleronboard-steps.component.css']
})
export class SelleronboardStepsComponent implements OnInit {

  @Input() step;
  currentStep = 1
  constructor() { }

  ngOnInit() {
    this.currentStep = this.step
  }

}
